export default __webpack_public_path__ + "static/media/favicon-v2.42d8c767.ico";